import { useEffect, useState } from "react";
import type { ProductContent } from "@itaas/pep-contracts";
import { getProductContent } from "../../api/pep-api";
import { isLocalVideoUrl, videoEmbedUrl } from "../../utils/video-embed";

export function ProductContentSection({ productSlug }: { productSlug: string }) {
  const [content, setContent] = useState<ProductContent | null>(null);

  useEffect(() => {
    getProductContent(productSlug)
      .then(setContent)
      .catch(() => setContent(null));
  }, [productSlug]);

  if (!content) return null;
  const hasVideo = Boolean(content.presentationVideo?.url);
  const hasFormations = content.formations.length > 0;
  if (!hasVideo && !hasFormations) return null;

  const pres = content.presentationVideo;
  const embed = pres ? videoEmbedUrl(pres.url, pres.source) : null;
  const isFile = pres ? isLocalVideoUrl(pres.url, pres.source) : false;

  return (
    <>
      {hasVideo && pres && embed && (
        <section className="mb-5">
          <h2 className="h4 fw-bold mb-3">{pres.title || "Présentation"}</h2>
          <div className="ratio ratio-16x9 rounded-3 overflow-hidden shadow-sm bg-dark">
            {isFile ? (
              <video src={embed} controls className="w-100 h-100" preload="metadata" />
            ) : (
              <iframe
                src={embed}
                title={pres.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-100 h-100 border-0"
              />
            )}
          </div>
        </section>
      )}

      {hasFormations && (
        <section className="mb-5">
          <h2 className="h4 fw-bold mb-3">Formations</h2>
          <div className="row g-3">
            {content.formations.map((f) => {
              const fEmbed = f.videoUrl ? videoEmbedUrl(f.videoUrl) : null;
              const fLocal = f.videoUrl ? isLocalVideoUrl(f.videoUrl) : false;
              return (
                <div className="col-md-6" key={f.id}>
                  <article className="card border-0 shadow-sm h-100">
                    <div className="card-body">
                      <h3 className="h6 fw-bold mb-1">{f.title}</h3>
                      {f.description && (
                        <p className="small text-secondary mb-2">{f.description}</p>
                      )}
                      {f.durationMin != null && (
                        <p className="small text-secondary mb-2">{f.durationMin} min</p>
                      )}
                      {f.videoUrl && fEmbed && (
                        <div className="ratio ratio-16x9 rounded overflow-hidden bg-body-tertiary">
                          {fLocal ? (
                            <video
                              src={fEmbed}
                              controls
                              className="w-100 h-100"
                              preload="metadata"
                            />
                          ) : (
                            <iframe
                              src={fEmbed}
                              title={f.title}
                              allowFullScreen
                              className="w-100 h-100 border-0"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
}
